"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "segusino": {
    "75a79b1e": [{
      "hkey": "3e4cf20d",
      "slug": "milies-stramare",
      "name": "Milies-Stramare",
      "primary": true,
      "skipSearch": false
    }],
    "milies": [{
      "hkey": "3e4cf20d",
      "slug": "milies-stramare",
      "name": "Milies-Stramare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b7f026c3": [{
      "hkey": "6db649c2",
      "slug": "segusino",
      "name": "Segusino",
      "primary": true,
      "skipSearch": false
    }],
    "riva-grassa": [{
      "hkey": "6db649c2",
      "slug": "segusino",
      "name": "Segusino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5f8edbd7": [{
      "hkey": "6db649c2",
      "slug": "segusino",
      "name": "Segusino",
      "primary": true,
      "skipSearch": false
    }],
    "riva-secca": [{
      "hkey": "6db649c2",
      "slug": "segusino",
      "name": "Segusino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b1fa8f93": [{
      "hkey": "3e4cf20d",
      "slug": "milies-stramare",
      "name": "Milies-Stramare",
      "primary": true,
      "skipSearch": false
    }],
    "stramare": [{
      "hkey": "3e4cf20d",
      "slug": "milies-stramare",
      "name": "Milies-Stramare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "segusino"
    }]
  }
};
exports["default"] = _default;